import {registerJQueryComponent} from '@lib/JQueryRegistry';

export default class DesktopNavigationBar {
    constructor(rootElement) {
        this.$dom = {
            root: rootElement,
            items: rootElement.find('.main-navigation-bar .navigation-bar-item'),
            submenuContainer: rootElement.find('.navigation-bar-submenu')
        };

        this.mayCloseSubmenu = true;
        this.activeSubmenu = null;
        this.activeNavigationBarItem = null;

        this.$dom.items.forEach(item => {
            this.initializeItem(item);
        });

        this.$dom.submenuContainer.on('mouseenter', () => {
            this.mayCloseSubmenu = false;
        });

        this.$dom.submenuContainer.on('mouseleave', () => {
            this.mayCloseSubmenu = true;
            this.handleMouseLeaveItem();
        });
    }

    initializeItem(item) {
        item.on('mouseenter', () => this.handleMouseOverItem(item));
        item.on('mouseleave', () => this.handleMouseLeaveItem(item));
    }

    handleMouseOverItem(item) {
        if (this.activeNavigationBarItem) {
            this.activeNavigationBarItem.removeClass('attr--hover');
        }

        if (this.activeSubmenu) {
            this.activeSubmenu.classList.remove('hover-visible');
        }

        this.activeSubmenu = this.findSubmenuElementById(item.data('submenu-id'));
        if (this.activeSubmenu === null) {
            return;
        }


        this.activeNavigationBarItem = item;
        item.addClass('attr--hover');

        this.activeSubmenu.classList.add('hover-visible');
        this.mayCloseSubmenu = false;
    }

    handleMouseLeaveItem(item) {
        if (!this.mayCloseSubmenu) {
            return;
        }

        if (this.activeSubmenu) {
            this.activeSubmenu.classList.remove("hover-visible");
            this.activeSubmenu = null;
        }

        if (this.activeNavigationBarItem) {
            this.activeNavigationBarItem.removeClass('attr--hover')
        }
        if (item)
            item.removeClass('attr--hover');
    }

    findSubmenuElementById(id) {
        return document.querySelector('[data-submenu-for="' + id + '"]');
    }
}

registerJQueryComponent(DesktopNavigationBar, '.navigation-bar-desktop');
